import { useSelector } from "react-redux";
import { useCallback } from "react";
import { useNavigate } from "react-router";

const useRouteLogic = () => {
   const {
      auth: {
         tokenData: { access_token },
      },
   } = useSelector((state) => state);
   const navigate = useNavigate();

   const redirectTologin = useCallback(() => {
      !access_token && navigate("/login");
   }, [access_token, navigate]);

   return { redirectTologin };
};

export default useRouteLogic;
